import { useMemo } from 'react';

import { Tabs } from '@bambi/component-library/src/components/Tabs/Tabs';
import { Navigate, useMatch, useNavigate } from 'react-router';

import { useUserRoles } from '../auth/useUserRoles';
import { MomentmSettingsTab } from './tabs/MomentmSettingsTab';
import { MTMSettingsTab } from './tabs/MTMSettingsTab';

export default function AdminScreen() {
  const { isBambi } = useUserRoles();
  const navigate = useNavigate();
  const route = useMatch('/admin/:tab');

  const defaultTab = useMemo(() => {
    if (!route) {
      return 'MTM';
    }

    if (route.params.tab === 'mtm') {
      return 'MTM';
    }

    return 'Momentm';
  }, [route]);

  if (!isBambi) {
    return <Navigate to="/" />;
  }

  return (
    <Tabs
      tabs={[
        {
          label: 'MTM',
          value: 'MTM',
          content: <MTMSettingsTab />,
        },
        {
          label: 'Momentm',
          value: 'Momentm',
          content: <MomentmSettingsTab />,
        },
      ]}
      defaultValue={defaultTab}
      onChange={(value) => {
        navigate(`/admin/${value.toLowerCase()}`);
      }}
    />
  );
}
